import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

const StockForm = ({ formData, handleInputChange, handleAddOrEditRow, handleReset, editingIndex }) => {
    return (
        <Box component="form" onSubmit={handleAddOrEditRow} noValidate sx={{ width: '100%' }}>
            <Paper elevation={2} sx={{ p: 2, mb: 3, borderLeft: 6, borderColor: 'primary.main' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Stock Name"
                            name="stockName"
                            value={formData.stockName}
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            type="number"
                            label="Holding Units"
                            name="holdUnit"
                            value={formData.holdUnit}
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            type="number"
                            label="Average Price"
                            name="avgPrice"
                            value={formData.avgPrice}
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
            </Paper>

            <Paper elevation={2} sx={{ p: 2, mb: 3, borderLeft: 6, borderColor: 'secondary.main' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            type="number"
                            label="New Investment"
                            name="newAmount"
                            value={formData.newAmount}
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            type="number"
                            label="Current Price"
                            name="currPrice"
                            value={formData.currPrice}
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
            </Paper>

            <Box sx={{ display: 'flex', gap: 2 }}>
                <Button variant="contained" color="primary" type="submit" size="large">
                    {editingIndex !== null ? 'Update' : 'Evaluate'}
                </Button>
                <Button variant="outlined" color="primary" onClick={handleReset} size="large">
                    Reset
                </Button>
            </Box>
        </Box>
    );
};

export default StockForm;
